export default "__VITE_ASSET__6c167876__"